import classNames from 'classnames';
import React from 'react';
import {Badge, Button} from 'reactstrap';
import type {DirectoryNode, DirectoryProperty} from '../../types';

type Props = {
    isRunning?: boolean;
    node: DirectoryNode;
    property: DirectoryProperty;
    onStart: (node: DirectoryNode, property: DirectoryProperty) => void;
    onStop: (node: DirectoryNode, property: DirectoryProperty) => void;
};

const ProgramRow: React.FC<Props> = ({isRunning, node, property, onStart, onStop}) => {
    const handleStart = React.useCallback(() => {
        onStart(node, property);
    }, [node, onStart, property]);
    const handleStop = React.useCallback(() => {
        onStop(node, property);
    }, [node, onStop, property]);
    return (
        <tr className={classNames({'table-info': isRunning})}>
            <td scope="row">{property.id}</td>
            <td>
                {isRunning ? <Badge pill color="info">running</Badge> : <Badge pill>stopped</Badge>}
            </td>
            <td>
                {isRunning ?
                    <Button color="danger" size="sm" onClick={handleStop}>Stop</Button> :
                    <Button color="success" size="sm" onClick={handleStart}>Start</Button>}
            </td>
        </tr>
    );
};

export default ProgramRow;
